import { render, staticRenderFns } from "./ModalPersonMember.vue?vue&type=template&id=b9a7775e&scoped=true"
import script from "./ModalPersonMember.vue?vue&type=script&lang=js"
export * from "./ModalPersonMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a7775e",
  null
  
)

export default component.exports